import React from 'react'
import './Partners.css'
import { images } from '../../../assets'

function Partners() {
  return (
    <div className='partners' >
        <div className='partner-content gridTable'>
            <div className='partnertitle' >Our Partners</div>
            <div className='table' >
                <div className="items"><img src={images.sbi} alt='sbi' /></div>
                <div className="items"><img src={images.hdfc} alt='hdfc' /></div>
                <div className="items"><img src={images.accenture} alt='accenture' /></div>
                <div className="items"><img src={images.vedanta} alt='vedanta' /></div>
                <div className="items"><img src={images.rblbank} alt='rbl' /></div>
                <div className="items"><img src={images.alkem} alt='alkem' /></div>
                <div className="items"><img src={images.hero} alt='hero' /></div>
                <div className="items"><img src={images.marico} alt='marico' /></div>
                <div className="items"><img src={images.suzlon} alt='suzlon' /></div>
                <div className="items"><img src={images.nmdc} alt='nmdc' /></div>
                <div className="items"><img src={images.nideo} alt='nideo' /></div>
                <div className="items"><img src={images.kshamata}alt='kshamta' /></div>
                <div className="items"><img src={images.hesco} alt='hesco' /></div>
                <div className="items"><img src={images.salam} alt='salam' /></div>
                <div className="items"><img src={images.sankalp} alt='sankalp' /></div>
            </div>

        </div>
      
    </div>
  )
}

export default Partners
